import React from "react";
import NotFoundContent from "@/components/organisms/NotFoundContent.jsx";

function NotFound() {
  return <NotFoundContent />;
}

export default NotFound;
